import Vue from 'vue'
import VueRouter from 'vue-router'


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

//引入其他文件
/**
 * 登录url
 */
import loginRouter from "@/router/login/login";


import indexRouter from "@/router/index/index";
import mineRouter from '@/router/mine/mine';
import goodsRouter from "@/router/goods/goods";
import orderRouter from "@/router/order/order";

import specialRouter from "@/router/special/special";
import returnGoodsRouter from "@/router/returnGoods/returnGoods";

const baseRoutes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/index/Home.vue'),
        meta: {
            showTab: true,
            keepAlive: true
        }
    },
    {
        path: '/category',
        name: 'Category',
        component: () => import('@/views/category/Category.vue'),
        meta: {
            showTab: true,
            keepAlive: true
        }
    },
    {
        path: '/special',
        name: 'Special',
        component: () => import('@/views/special/Special.vue'),
        meta: {
            showTab: true,
            keepAlive: true
        }
    },
    {
        path: '/mine',
        name: 'Mine',
        component: () => import('@/views/mine/Mine.vue'),
        meta: {
            showTab: true ,
            keepAlive: false
        }
    }
];

const routes = baseRoutes.concat(mineRouter, goodsRouter, orderRouter, indexRouter, specialRouter, returnGoodsRouter, loginRouter);


const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    // scrollBehavior (to, from, savedPosition) {
    //
    //     // return 期望滚动到哪个的位置
    // }
});



export default router
